import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import SaveIcon from "@material-ui/icons/Save";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { loadShopData } from "../actions/shopLoadData";
import { shopSaveInputsAction } from "../actions/shopSaveCategory";
import { IP } from "../config/IP";
import store from "../store/createStore";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiTextField-root": {
			margin: theme.spacing(1),
			width: "25ch",
		},
		formControl: {
			margin: theme.spacing(1),
			width: "25ch",
		},
		selectEmpty: {
			marginTop: theme.spacing(2),
		},
		fab: {
			position: "absolute",
			bottom: theme.spacing(2),
			right: theme.spacing(2),
		},

		wrapper: {
			margin: theme.spacing(1),
			position: "relative",
		},
	},
}));

export default function AddNewProductForm(props, ref) {
	const [success, setSuccess] = React.useState(false);
	const history = useHistory();
	const classes = useStyles();
	const state = useSelector((state) => state);
	const buttonClassname = clsx({
		[classes.buttonSuccess]: success,
	});
	const [saleUnitPrice, setsaleUnitPrice] = React.useState();

	const [measure, setMeasure] = React.useState("NUMBER");
	const [currency, setCurrency] = React.useState("RWF");
	const [loading, setLoading] = React.useState(false);
	const [productName, setProductName] = React.useState("");
	const [discount, setDiscount] = React.useState(0);
	const [discountToDate, setDiscountToDate] = React.useState("");
	const [discountFromDate, setDiscountFromDate] = React.useState("");
	let errorv = { name: false, price: false, measure: false, currency: false };
	const [error, setError] = React.useState(errorv);

	const handleSaveNewProduct = async () => {
		let inputs = {
			url: IP.nodeServer + "api/editShopCategoryDetails",
			method: "POST",
			data: [
				{
					name: "action",
					value: "insert_new_product",
				},

				{
					name: "productName",
					value: productName,
				},
				{
					name: "saleUnitPrice",
					value: saleUnitPrice,
				},
				{
					name: "categoryId",
					value: props.categoryId,
				},
				{
					name: "subCategoryId",
					value: props.subCategoryId,
				},
				{
					name: "discount",
					value: discount,
				},
				{
					name: "discountToDate",
					value: discount !== 0 ? discountToDate : "",
				},
				{
					name: "discountFromDate",
					value: discount !== 0 ? discountFromDate : "",
				},
				{
					name: "currency",
					value: currency,
				},
				{
					name: "measure",
					value: measure,
				},
			],
		};
		if (productName && saleUnitPrice && currency && measure) {
			setSuccess(true);
			await store.dispatch(shopSaveInputsAction(inputs));
			inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{ name: "companyId", value: state.auth.user.allCompanies[0]._id },
				],
			};
			console.log("loadShopData=", inputs);
			await store.dispatch(loadShopData(inputs));
			history.goBack();
		} else {
			setSuccess(false);
			if (!productName) {
				errorv = { ...errorv, name: true };
			} else {
				errorv = { ...errorv, name: false };
				setSuccess(true);
			}
			if (!currency) {
				errorv = { ...errorv, currency: true };
			} else {
				errorv = { ...errorv, currency: false };
			}
			if (!measure) {
				errorv = { ...errorv, measure: true };
			} else {
				errorv = { ...errorv, measure: false };
			}
			if (!saleUnitPrice) {
				errorv = { ...errorv, price: true };
			} else {
				errorv = { ...errorv, price: false };
			}
			setError(errorv);
		}

		console.log("handleSaveNewProduct inputs=", inputs);
	};
	const handleChangeDiscountToDate = (event) => {
		setDiscountToDate(event.target.value);
	};
	const handleChangeDiscountFromDate = (event) => {
		setDiscountFromDate(event.target.value);
	};
	const handleChangeDiscount = (event) => {
		if (event.target.value >= 100)
			setDiscount(event.target.value ? event.target.value : 0);
	};
	const handleChangesaleUnitPrice = (event) => {
		setsaleUnitPrice(event.target.value);
	};
	const handleChangeProductName = (event) => {
		setProductName(event.target.value);
	};
	const handleChangeMeasure = (event) => {
		console.log("handleChangeMeasure=", event.target.value);
		setMeasure(event.target.value);
	};

	const handleChangeCurrency = (event) => {
		console.log("handleChangeCurrency=", event.target.value);
		setCurrency(event.target.value);
	};

	// load new info after saving sub category
	React.useEffect(() => {
		if (state.shopSaveInfo.isSave) {
			setSuccess(true);
			let inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [
					{
						name: "companyId",
						value: state.companyData.selectedCompanyId,
					},
				],
			};
			console.log("loadShopData");
			store.dispatch(loadShopData(inputs));
		}
	}, [state.shopSaveInfo.isSave]);

	console.log("categoryId=", props.categoryId);
	console.log("subCategoryId=", props.subCategoryId);

	return (
		<div>
			{false && (
				<>
					<div>{"categoryId=" + props.categoryId}</div>
					<div>{"subCategoryId=" + props.subCategoryId}</div>
				</>
			)}

			<form className={classes.root} noValidate autoComplete="off">
				<div>
					<TextField
						error={error.name}
						required
						id="outlined-required"
						label="product Name"
						placeholder="product Name"
						variant="outlined"
						onChange={handleChangeProductName}
					/>
					<TextField
						error={error.price}
						required
						id="outlined-required"
						type="number"
						label="sale Unit Price"
						placeholder="sale Unit Price"
						variant="outlined"
						onChange={handleChangesaleUnitPrice}
					/>
					<TextField
						error={error.discount}
						required
						id="outlined-required"
						type="number"
						label="discount %"
						defaultValue={0}
						placeholder="discount"
						InputProps={{
							inputProps: {
								max: 100,
								min: 0,
							},
						}}
						variant="outlined"
						onChange={handleChangeDiscount}
					/>
					<TextField
						error={error.discountFromDate}
						id="discountFromDate"
						label="discount From Date"
						type="date"
						defaultValue={new Date()}
						className={classes.textField}
						InputLabelProps={{
							shrink: true,
						}}
						onChange={handleChangeDiscountFromDate}
					/>
					<TextField
						error={error.discountToDate}
						id="discountToDate"
						label="discountToDate"
						type="date"
						defaultValue={new Date()}
						className={classes.textField}
						InputLabelProps={{
							shrink: true,
						}}
						onChange={handleChangeDiscountToDate}
					/>

					<TextField
						error={error.measure}
						id="standard-select-measure"
						select
						label="Measure"
						value={measure}
						helperText="Please select your measure"
						onChange={handleChangeMeasure}
					>
						<MenuItem value={"NUMBER"}>Number</MenuItem>

						<MenuItem value={"KILO"}>KG</MenuItem>
						<MenuItem value={"LITER"}>Liter</MenuItem>
					</TextField>

					<TextField
						error={error.currency}
						id="standard-select-currency"
						select
						label="currency"
						value={currency}
						helperText="Please select your currency"
						onChange={handleChangeCurrency}
					>
						<MenuItem value={"RWF"}>RWF</MenuItem>
					</TextField>
					<div className={classes.wrapper}>
						<Fab
							aria-label="save"
							color="primary"
							className={buttonClassname}
							onClick={handleSaveNewProduct}
						>
							{success ? <SaveIcon /> : <SaveIcon />}
						</Fab>
						{state.shopSaveInfo.isSaving && (
							<CircularProgress size={68} className={classes.fabProgress} />
						)}
					</div>
				</div>
			</form>
		</div>
	);
}
